import { Connector, ConnectorCreateBody,ConnectorFilters } from "@/@types/ivr";
import httpManager from "@/app/shared/utils/httpManager";

class ConnectorServices {
    private baseUrl = "/ivr/api-connector";

    async getList(filters?: ConnectorFilters): Promise<Connector[]> {
        const query = new URLSearchParams();

        query.set("name", filters?.name ?? "");
        query.set("status", String(filters?.status ?? ""));

        const url = `${this.baseUrl}/?${query.toString()}`;

        const response = await httpManager.get(url);

        return response.data;
    }

    async getDetails(id: number | string): Promise<Connector> {
        const url = `${this.baseUrl}/${id}/`;
        
        const response = await httpManager.get(url);
        
        return response.data;
    }

    async create(newConnector: ConnectorCreateBody): Promise<Connector> {
        const url = `${this.baseUrl}/`;
    
        const response = await httpManager.post(url, newConnector);
    
        return response.data;
    }

    async update(id: number, newConnectorData: Partial<ConnectorCreateBody>) {
        const url = `${this.baseUrl}/${id}/`;
    
        return await httpManager.put(url, newConnectorData);
    }

    async delete(id: number) {
        const url = `${this.baseUrl}/${id}/`;

        await httpManager.delete(url);
    }

    async validateName(name: string): Promise<Connector[]> {
        const response = await httpManager.get(`${this.baseUrl}/validate-name/?name=${name}`);

        return response.data;
    }
}

export const connectorServices = new ConnectorServices();